'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { usePathname } from 'next/navigation';

export function FooterNavigation({ menu }: { menu: Menu }) {
  const pathname = usePathname();

  return (
    <div
      className={cn(
        'custom-container',
        'hidden items-center justify-center gap-6 border-t border-t-white/20 sm:flex md:gap-8',
      )}
    >
      {menu.fields.map(item => {
        const isActive = pathname === item.path;

        return (
          <Link
            key={item.name}
            prefetch={false}
            href={getSafeHref(item?.path ?? '/')}
            className={cn(
              'flex h-[100px] items-center justify-center text-white',
              isActive && 'ea-footer__active-item',
            )}
          >
            {item.name}
          </Link>
        );
      })}
    </div>
  );
}
